import { JSX, useId } from "react";
import styled from "styled-components";

export interface Definition {
  readonly term: string;
  readonly description: string;
}

export interface DefinitionListProps {
  readonly contents: Definition[];
}

export function DefinitionList({ contents }: DefinitionListProps) {
  return (
    <List role="list">
      {contents.map((pair) => (
        <Definition key={pair.term} term={pair.term} description={pair.description} />
      ))}
    </List>
  );
}

function Definition({ term, description }: Definition): JSX.Element {
  const id = useId();
  return (
    <>
      <Term id={id}>{term}</Term>
      <Description aria-labelledby={id}>{description}</Description>
    </>
  );
}

const List = styled.dl`
  display: grid;
  grid-template-columns: max-content auto;
  column-gap: var(--tractie-spacing-gap-l);
  row-gap: var(--tractie-spacing-gap-xs);
  margin: 0;
`;

const Term = styled.dt`
  color: var(--tractie-color-content-subtle);
  margin: 0;
  font-weight: var(--tractie-typography-weight-medium);
  font-size: var(--tractie-typography-size-s);
`;

const Description = styled.dd`
  margin: 0;
  font-size: var(--tractie-typography-size-s);
`;
